import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.fixed.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useProduct } from '~/composables/_next/useProduct';
import AzImg from '~/components/Atoms/AzImg.vue';
import AzRating from '~/components/_next/atoms/AzRating.vue';
import useRightPath from '~/composables/useRightPath';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { SCHEMA_REVIEW, SCHEMA_PERSON, SCHEMA_RATING } from '~/constants';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CardRatingAndReviews',
  props: {
    homeRatingAndReview: {
      type: Boolean,
      default: false
    },
    rating: {
      type: Number,
      default: 0
    },
    customerServiceResponses: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    urlImg: {
      type: String,
      default: ''
    },
    productName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    picture: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    productLink: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var _props$customerServic, _props$customerServic2, _props$customerServic3, _props$customerServic4, _props$customerServic5, _props$customerServic6;
    var props = __props;
    var AzExpandableText = function AzExpandableText() {
      return import('~/components/_next/molecules/AzExpandableText.vue');
    };
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app;
    var _useProduct = useProduct('products'),
      search = _useProduct.search,
      products = _useProduct.products;
    var _useRightPath = useRightPath(),
      getProductPrefix = _useRightPath.getProductPrefix;
    var linkProduct = useState('card-rating-link-product', function () {
      return '';
    });
    var customerServiceResponseStandardise = reactive({
      date: (props === null || props === void 0 ? void 0 : (_props$customerServic = props.customerServiceResponses) === null || _props$customerServic === void 0 ? void 0 : (_props$customerServic2 = _props$customerServic[0]) === null || _props$customerServic2 === void 0 ? void 0 : _props$customerServic2.date) || (props === null || props === void 0 ? void 0 : (_props$customerServic3 = props.customerServiceResponses) === null || _props$customerServic3 === void 0 ? void 0 : (_props$customerServic4 = _props$customerServic3[0]) === null || _props$customerServic4 === void 0 ? void 0 : _props$customerServic4.comment_date),
      comment: props === null || props === void 0 ? void 0 : (_props$customerServic5 = props.customerServiceResponses) === null || _props$customerServic5 === void 0 ? void 0 : (_props$customerServic6 = _props$customerServic5[0]) === null || _props$customerServic6 === void 0 ? void 0 : _props$customerServic6.comment
    });
    var isOldCustomerService = computed(function () {
      return props.description === 'Texte Invisible';
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!props.homeRatingAndReview) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return fetchAverageReviews(props.productLink);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    useLazyAsyncData('consumerAdvice-cardRatingAndReviews', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!props.homeRatingAndReview) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return fetchAverageReviews(props.productLink);
          case 3:
            return _context2.abrupt("return", true);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    function fetchAverageReviews(_x) {
      return _fetchAverageReviews.apply(this, arguments);
    }
    function _fetchAverageReviews() {
      _fetchAverageReviews = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(sku) {
        var _response$value$;
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return search({
                skus: sku
              });
            case 2:
              _context3.next = 4;
              return products;
            case 4:
              response = _context3.sent;
              linkProduct.value = app.localePath("".concat(getProductPrefix(), "/").concat((_response$value$ = response.value[0]) === null || _response$value$ === void 0 ? void 0 : _response$value$._slug));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _fetchAverageReviews.apply(this, arguments);
    }
    var getRandomColorArray = function getRandomColorArray() {
      var arrayColors = ['#FFF7E0', '#FBEDEC', '#FFEDDD', '#F2EDFF'];
      var color = arrayColors[Math.floor(Math.random() * 3)];
      return color;
    };
    var firstLetterToUpper = function firstLetterToUpper(word) {
      if (!word) return;
      return word[0].toUpperCase() + word.slice(0, 0);
    };
    var removeMicroseconds = function removeMicroseconds(dateStr) {
      return dateStr && dateStr.split('.')[0];
    };
    var wasPublishedAgo = function wasPublishedAgo(dateString) {
      var cleanedDateString = removeMicroseconds(dateString);
      var date = new Date(cleanedDateString);
      var today = new Date();
      var diff = date > today ? new Date(date - today) : new Date(today - date);
      var diffInDays = Math.floor(diff / (1000 * 60 * 60 * 24));
      var times = [{
        limit: 0,
        key: 'today'
      }, {
        limit: 1,
        key: 'day'
      }, {
        limit: 30,
        key: 'days',
        factor: 1
      }, {
        limit: 365,
        key: 'month',
        factor: 30
      }, {
        limit: 730,
        key: 'year',
        factor: 365,
        fixed: 1
      }, {
        limit: Infinity,
        key: 'years',
        factor: 365
      }];
      for (var _i = 0, _times = times; _i < _times.length; _i++) {
        var time = _times[_i];
        if (diffInDays < time.limit) {
          var name = time.fixed || Math.floor(diffInDays / time.factor);
          return translate("ratingReviews.".concat(time.key)).replace('{name}', name);
        }
      }
    };
    function getFirstName(fullName) {
      var splitName = fullName.split(' ');
      var firstName = splitName[0];
      var firstNameWithFirstLetterUpperCase = firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
      return firstNameWithFirstLetterUpperCase;
    }
    var ifAnonymous = function ifAnonymous(name) {
      if (name === 'anonymous') {
        return firstLetterToUpper(name);
      } else {
        return getFirstName(name);
      }
    };
    return {
      __sfc: true,
      AzExpandableText: AzExpandableText,
      props: props,
      translate: translate,
      app: app,
      search: search,
      products: products,
      getProductPrefix: getProductPrefix,
      linkProduct: linkProduct,
      customerServiceResponseStandardise: customerServiceResponseStandardise,
      isOldCustomerService: isOldCustomerService,
      fetchAverageReviews: fetchAverageReviews,
      getRandomColorArray: getRandomColorArray,
      firstLetterToUpper: firstLetterToUpper,
      removeMicroseconds: removeMicroseconds,
      wasPublishedAgo: wasPublishedAgo,
      getFirstName: getFirstName,
      ifAnonymous: ifAnonymous,
      AzImg: AzImg,
      AzRating: AzRating,
      SCHEMA_REVIEW: SCHEMA_REVIEW,
      SCHEMA_PERSON: SCHEMA_PERSON,
      SCHEMA_RATING: SCHEMA_RATING,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});